import { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { globalHistory } from '@reach/router';
import { PageTransitionController, getSettings } from './PageTransition.utils';
import useScroll from '../../../foundation/hooks/use-scroll/use-scroll';
import { AnimationsSettingsContext } from '../../context';
import './PageTransition.less';
var propTypes = {
  transition: PropTypes.string,
  durationIn: PropTypes.number,
  durationOut: PropTypes.number,
  parentSelector: PropTypes.string
};
var defaultProps = {
  transition: null,
  durationIn: null,
  durationOut: null,
  parentSelector: null
};
export default function PageTransition(_ref) {
  var transitionProp = _ref.transition,
    durationInProp = _ref.durationIn,
    durationOutProp = _ref.durationOut,
    parentSelector = _ref.parentSelector;
  var _useScroll = useScroll(),
    enableScroll = _useScroll.enableScroll,
    disableScroll = _useScroll.disableScroll;
  var animationsContext = useContext(AnimationsSettingsContext);
  function onRouteChange(controller) {
    controller.pageIn();
  }
  var _getSettings = getSettings({
      transition: transitionProp,
      durationIn: durationInProp,
      durationOut: durationOutProp,
      animationsContext: animationsContext
    }),
    enabled = _getSettings.enabled,
    transition = _getSettings.transition,
    durationIn = _getSettings.durationIn,
    durationOut = _getSettings.durationOut;
  useEffect(function () {
    var controller = new PageTransitionController({
      enabled: enabled,
      transition: transition,
      durationIn: durationIn,
      durationOut: durationOut,
      parentSelector: parentSelector,
      onPreAnimation: disableScroll,
      onPostAnimation: enableScroll
    });
    var unsubscribe = globalHistory.listen(function () {
      onRouteChange(controller);
    });
    return unsubscribe;
  }, []);
  return null;
}
PageTransition.propTypes = propTypes;
PageTransition.defaultProps = defaultProps;